import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { array, number, func, object } from 'prop-types'
import { Form, Input, InputNumber, Select, Checkbox, Typography } from 'antd'
import {
	editTemplateStepRemove,
	editTemplateMove,
} from '~/states/modules/editTemplate'
import DragDropCard from '~/components/dragDropCard'
import Delete from '~/components/deleteConfirm'

const { Text } = Typography

const InternalApprovalStep = ({
	form,
	step,
	index,
	loadGroups,
	groupOptions,
	updateStep,
}) => {
	const dispatch = useDispatch()
	const titleFormItemName = `description_${index}`
	const responsibleGroupFormItemName = `group_${index}`
	const deadlineFormItemName = `deadline${index}`

	const [expire, setExpire] = useState(!(step.deadline === null))

	const updateResponsibleGroup = (event) => {
		const responsible_group = event ? event : null
		updateStep(index, { responsible_group })
	}

	const updateStepProperty = (propertyName, propertyValue) => {
		updateStep(index, { [propertyName]: propertyValue })
	}

	const handleRemoveStep = () => {
		dispatch(editTemplateStepRemove({ index }))
		form.setFieldsValue({
			[titleFormItemName]: '',
			[responsibleGroupFormItemName]: null,
			[deadlineFormItemName]: null,
		})
	}

	return (
		<DragDropCard index={index} move={editTemplateMove} name={'workflow'}>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					height: '32px',
					marginBottom: '24px',
				}}>
				<Form.Item
					name={titleFormItemName}
					label="Descrição"
					rules={[{ required: true, message: 'Este campo é obrigatório.' }]}
					initialValue={step.title}>
					<Input
						onChange={(event) => {
							updateStepProperty('title', event.target.value)
						}}
					/>
				</Form.Item>
				<Delete
					handle={() => handleRemoveStep()}
					title="Deseja excluir esse passo?"
				/>
			</div>
			<Form.Item
				name={responsibleGroupFormItemName}
				label="Grupo"
				initialValue={step.responsible_group?.name}>
				<Select
					allowClear
					style={{ width: '100%' }}
					placeholder="Selecione o grupo"
					options={groupOptions}
					onFocus={() => loadGroups(step.responsible_group)}
					onChange={updateResponsibleGroup}
				/>
			</Form.Item>
			<div style={{ display: 'flex', marginBottom: '10px' }}>
				<Checkbox
					checked={expire}
					onChange={(event) => {
						// TODO: Do we need has_deadline and expire? They seem to do the same thing.
						const has_deadline = event.target.checked
						setExpire(event.target.checked)
						updateStepProperty('deadline', has_deadline ? 1 : null)
						form.setFieldsValue({
							[deadlineFormItemName]: 1,
						})
					}}>
					Prazo de validade{expire && ':'}
				</Checkbox>
				{expire && (
					<>
						<Form.Item
							name={deadlineFormItemName}
							rules={[{ required: true, message: 'Este campo é obrigatório.' }]}
							style={{ position: 'relative', bottom: '5px', margin: 0 }}
							initialValue={step.deadline}>
							<InputNumber
								value={step.deadline}
								min={1}
								size="small"
								style={{ width: '60px', marginRight: '5px' }}
								onChange={(event) => {
									updateStepProperty('deadline', event)
								}}
							/>
						</Form.Item>
						<Text>dia{step.deadline !== 1 && 's'}</Text>
					</>
				)}
			</div>
		</DragDropCard>
	)
}

export default InternalApprovalStep

InternalApprovalStep.propTypes = {
	form: object,
	step: object,
	index: number,
	loadGroups: func,
	groupOptions: array,
	updateStep: func,
}

InternalApprovalStep.defaultProps = {
	groups: [],
}
